import { render, staticRenderFns } from "./ManteCartaRestaurante.vue?vue&type=template&id=12d05d5d&"
import script from "./ManteCartaRestaurante.vue?vue&type=script&lang=js&"
export * from "./ManteCartaRestaurante.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports